import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="max-w-3xl mx-auto">
        <Link to="/">
          <Button variant="ghost" className="mb-6 gap-2">
            <ArrowLeft className="w-4 h-4" />
            Retour
          </Button>
        </Link>
        
        <h1 className="text-3xl font-bold mb-6">Politique de Confidentialité</h1>
        
        <div className="prose prose-slate max-w-none space-y-4">
          <p><strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR')}</p>
          
          <h2 className="text-xl font-semibold mt-6">1. Collecte des données</h2>
          <p>
            SocialHub collecte les informations suivantes lorsque vous utilisez notre service :
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Informations de compte des réseaux sociaux connectés (Facebook, Instagram, TikTok)</li>
            <li>Contenu des publications que vous créez</li>
            <li>Médias (images et vidéos) que vous uploadez</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6">2. Utilisation des données</h2>
          <p>
            Nous utilisons vos données uniquement pour :
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Publier du contenu sur vos réseaux sociaux selon vos instructions</li>
            <li>Planifier vos publications</li>
            <li>Afficher l'historique de vos publications</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6">3. Partage des données</h2>
          <p>
            Nous ne vendons pas vos données. Vos informations sont partagées uniquement avec les plateformes 
            de réseaux sociaux que vous connectez (Facebook, Instagram, TikTok) dans le but de publier votre contenu.
          </p>
          
          <h2 className="text-xl font-semibold mt-6">4. Sécurité</h2>
          <p>
            Nous utilisons des mesures de sécurité standard pour protéger vos données, incluant le chiffrement 
            des tokens d'accès et des connexions HTTPS.
          </p>
          
          <h2 className="text-xl font-semibold mt-6">5. Vos droits</h2>
          <p>
            Vous pouvez à tout moment :
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Déconnecter vos comptes de réseaux sociaux</li>
            <li>Supprimer vos publications de notre système</li>
            <li>Demander la suppression de toutes vos données</li>
          </ul>
          
          <h2 className="text-xl font-semibold mt-6">6. Contact</h2>
          <p>
            Pour toute question concernant cette politique, contactez-nous via l'application.
          </p>
        </div>
      </div>
    </div>
  );
}
